import PasswordReset from './Container';

export default PasswordReset;
